import Constants from "../../common/constants";

export const clearCart = () => {
  if (localStorage.getItem(Constants.STORAGE_LINE_ITEMS_KEY)) {
    localStorage.removeItem(Constants.STORAGE_LINE_ITEMS_KEY);
  }
};
